import HelpContent from './HelpContent'
import React from 'react'
import { PageTitle } from '../../../components/PageTitle'
import { FilterContainer } from './Filters/FilterContainer'
import { MobileFilterContainer } from './MobileFilterContainer'
import { HorizontalStack, Switch } from '@ztechapps/webui.util'
import { DesktopToggleViewLayoutButton } from './ToggleViewLayoutButton'
import { ListView } from './list-view'

import { GridView } from './grid-view'
import { useContext } from './Context'
import { MobileFilterButton } from './MobileFilterButton'

import { ViewLayoutType } from '../../../config/types'

export const Content = () => {
  const { viewLayout, productsCount } = useContext()

  return (
    <section className="pb-4">
      <PageTitle
        title="Search Results"
        description={`Browse ${productsCount} high-quality panel punches and metal fabrication tools. Find the perfect tools for your metalworking needs.`}
      />
      <div className="container mt-2">
        <div className="row">
          <aside className="col-md-3 d-none d-lg-block">
            <FilterContainer />
          </aside>
          <main className="col-md-12 col-lg-9">
            <HorizontalStack className="justify-content-between my-1">
              <div>
                <strong>{productsCount} product(s) found </strong>
              </div>
              <MobileFilterButton />
              <DesktopToggleViewLayoutButton />
            </HorizontalStack>
            <div>
              <Switch expression={viewLayout}>
                {{
                  [ViewLayoutType.grid]: <GridView />,
                  [ViewLayoutType.list]: <ListView />,
                }}
              </Switch>
            </div>

            <HelpContent />
          </main>
        </div>
        <MobileFilterContainer />
      </div>
    </section>
  )
}
